import * as React from 'react';
import { ReactElement } from 'react';
import { Row } from '../box/Box';
import { Spacer } from '../spacer/Spacer';
import { Font } from '../text/font';
import { CoreProps } from '../types';

const { FuturaBook } = Font;

interface InputMessageProps {
    type: string;
    message: string;
}

export const InputMessage = (props: InputMessageProps & CoreProps): ReactElement => {
    const { type, message, className } = props;
    const errorClass = type === 'error' ? 'error-message' : type === 'warning' ? 'warning-message' : type === 'success' ? 'success-message' : 'error-message';
    const clss = ['input-message-default', errorClass, className].filter(Boolean).join(' ');

    return (
        <React.Fragment>
            <div className={clss}>
                {/* <Spacer.M /> */}

                <Row className="error-message-row">
                    <div className="error-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            {type !== 'success' && (
                                <path
                                    fill="#D14563"
                                    d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                                />
                            )}
                            {type === 'success' && (
                                <path
                                    fill="green"
                                    d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                />
                            )}
                        </svg>
                    </div>

                    <FuturaBook mobile="12" className="error-message-text">
                        {message}
                    </FuturaBook>
                </Row>
            </div>
        </React.Fragment>
    );
};
